//import Vue from 'vue'
import moment from 'moment'

import COMMON from '@/plugins/handsontable_common'

const _DATA = () => {
//    function sourceCouriers() {
//        return {
//            'dhl': 'dhl',
//            'fedex': 'fedex',
//            'ups': 'ups',
//            'japanpost': '日本郵便',
//            'ecms': 'ECMS',
//            'orangeconnex': 'OrangeConnex',
//        }
//    }
    // SHIPPING_ECMS_TABLE
    const DATA = {}
    DATA.METHODS = {
        data2JsonObject: (data) => {
            return data
                .map((v) => {
                    let data = {}
                    for (let i = 0; i < DATA.FIELDS_ALL.length; i++) {
                        data[DATA.FIELDS_ALL[i].name] = DATA.FIELDS_ALL[i].get(v[i], v)
                    }
                    return data
                })
        },
    }
    // SHIPPING_ECMS_TABLE
    DATA.RENDERERS = {
        sku: (instance, td, row, col, prop, value, cellProperties) => {
            td.innerHTML = ''
            if (cellProperties.readOnly) {
                td.classList.add('htDimmed')
            }
            if (value) {
                const values = value.split("\n")
                for (let i = 0; i < values.length; i++) {
                    const a = document.createElement('a')
                    a.href = 'javascript:void(0)'
                    a.classList.add('text-primary')
                    a.innerHTML = `${values[i]}`
                    td.appendChild(a)
                    td.appendChild(document.createElement('br'))

                    a.addEventListener('click', e => {
                        const vue = instance.getSettings()._vue
                        const sku = e.target.innerText
                        vue.onClickSelectSkuIndividually(sku)
//                        console.log(instance.getSettings()._vue)
                        // TODO: access vue instance
                        e.preventDefault()
                        e.stopPropagation()
                    })
                }
            }
            return td
        },
    }
    // SHIPPING_ECMS_TABLE
    DATA.FIELDS = {
        // システム入力
        SYSTEM: [
            {
                name: 'SellerUserID',
                get: (v, v_all) => { return v },
                load: (v) => { return v.sellerId },
                colHeader: 'SellerUserID',
                column: {
                },
                readOnly: true,
            },
            {
                name: 'order_id',
                get: (v, v_all) => { return v },
                load: (v) => { return v.orderId },
                colHeader: '注文番号',
                column: {
                    type: 'text',
                },
                readOnly: false,
            },
            {
                name: 'CreatedTime',
                get: (v, v_all) => { return v },
                load: (v) => { return v.creationDate },
                colHeader: '注文日',
                column: {
                    renderer: COMMON().RENDERERS.YYYY_MM_DD_hh_mm,
                },
                readOnly: true,
            },
            {
                name: 'sku',
                get: (v, v_all) => { return v },
                load: (v) => { return v.lineItems.map(v => v.sku).join('\n') },
                colHeader: 'SKU',
                column: {
                    type: 'text',
                    renderer: DATA.RENDERERS.sku,
                },
                readOnly: true,
            },
            {
                name: 'item_title',
                get: (v, v_all) => { return v },
                load: (v) => { return v.lineItems.map(v => v.title).join('\n') },
                colHeader: '商品名',
                column: {
                    type: 'text',
                },
                readOnly: true,
            },
            {
                name: 'quantity',
                get: (v, v_all) => { return v },
                load: (v) => { return v.lineItems.map(v => v.quantity).join('\n') },
                colHeader: 'quantity',
                column: {
                    type: 'text',
                    className: 'text-right',
                },
                readOnly: true,
            },
            {
                name: 'cost',
                get: (v, v_all) => { return v },
                load: (v) => { return v.lineItems.map(v => v.lineItemCost.value).join('\n') },
                colHeader: 'cost',
                column: {
                    type: 'text',
                    className: 'text-right',
                },
                readOnly: true,
            },
        ],
        // 発送情報
        COURIER: [
        ],
        SYSTEM_UPDATED_AT: [
            {
                name: 'updated_at',
                get: (v, v_all) => { return v },
                load: (v) => { return v.updated_at },
                colHeader: 'updated_at',
                column: {
                    type: 'text',
                },
                readOnly: true,
            },
        ],
        // 登記
        PROFILE: [
        ],
        // 発送人
        FROM: [
        ],
        // 受取人
        TO: [
            {
                name: 'to_name',
                get: (v, v_all) => { return v },
                load: (v) => { return v.fulfillmentStartInstructions[0].shippingStep.shipTo.fullName },
                colHeader: '荷受人',
                column: {
//                    renderer: COMMON().RENDERERS.LAST_NAME,
                },
                readOnly: false,
            },
        ],
        // 輸入者
        IMPORTER: [
        ],
        // 発送情報
        SHIPPING: [
        ],
    }
    DATA.FIELDS_ALL =
        DATA.FIELDS.SYSTEM
        .concat(DATA.FIELDS.COURIER)
        .concat(DATA.FIELDS.SYSTEM_UPDATED_AT)
        .concat(DATA.FIELDS.PROFILE)
        .concat(DATA.FIELDS.FROM)
        .concat(DATA.FIELDS.TO)
        .concat(DATA.FIELDS.IMPORTER)
        .concat(DATA.FIELDS.SHIPPING)
    return DATA
}

export default _DATA

